import React from "react";
import Content from "../../layout/content/Content";

const Index = () => {
  return <Content>Under Development</Content>;
};

export default Index;
